import { render, staticRenderFns } from "./payment-type-pill.vue?vue&type=template&id=1119b569&scoped=true&"
import script from "./payment-type-pill.vue?vue&type=script&setup=true&lang=js&"
export * from "./payment-type-pill.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./payment-type-pill.vue?vue&type=style&index=0&id=1119b569&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1119b569",
  null
  
)

export default component.exports